export default __webpack_public_path__ + "static/media/botas-largas-mujer.d840c94e.png";